import React from "react";
import { Button, Message } from "semantic-ui-react";
import { uploadFileToCoreApi } from "utilities/fileUploadUtils";
import { Modal } from "../../../components";
import FakeProgress from "../../../components/FakeProgress";

interface Props {
  documentId: number
  isOpen: boolean
  onClose: () => void
}

const ManualCompleteModal = (props: Props) => {
  const [error, setError] = React.useState<string>(undefined);
  const [isUploading, setIsUploading] = React.useState(false);
  const [hasFinishedUploading, setHasFinishedUploading] = React.useState(false);

  const fileRef = React.useRef<HTMLInputElement>(null);

  const onUploadClick = () => {
    fileRef.current?.click();
  };

  const onFileSelected = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target;

    if (files.length === 0) {
      return;
    }

    setIsUploading(true);
    setHasFinishedUploading(false);
    const res = await uploadFileToCoreApi(
      window.CoreApi.ESign.ManualComplete,
      window.CoreApi.ESign.ManualComplete.absoluteUrl(),
      {
        file: files[0],
        documentId: props.documentId
      },
      { fileType: "pdf" }
    );
    if (res.data.hasErrors) {
      setIsUploading(false);
      setError(res.data.errors[0].message);
      return;
    }
    setHasFinishedUploading(true);
  };

  const onProgressFinish = () => {
    window.location.reload();
  };

  return <Modal
    isOpen={props.isOpen}
    handleClose={props.onClose}
    width="tiny"
    title={RESX.ESign.CompleteManually}
  >
    <div className="grow1">
      <Message color="blue">
        {RESX.ESign.CompleteManuallyWarning}
      </Message>
    </div>

    {error && <Message color="red" className="margin-top">
      {error}
    </Message>}

    <div className="flex justify-end margin-top-bigger">
      <Button loading={isUploading} disabled={isUploading} color="blue" onClick={onUploadClick}>
        Upload PDF
      </Button>
    </div>

    {isUploading && <FakeProgress
      isDone={hasFinishedUploading}
      onFinish={onProgressFinish}
    />}

    <input ref={fileRef} type="file" onChange={onFileSelected} style={{ display: "none" }} />
  </Modal>;
};

export default ManualCompleteModal;